"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _RedditSubApi = require("@/libs/RedditSubApi");
var _default = exports.default = {
  data() {
    return {
      visible: false,
      loading: false,
      loadError: '',
      posts: [],
      redditOAuthConnected: false,
      oauthBusy: false
    };
  },
  computed: {
    isElectron() {
      return typeof window !== 'undefined' && window.electronAPI && typeof window.electronAPI.redditGetPosts === 'function';
    },
    oauthClientConfigured() {
      return !!String(this.$state.setting('reddit.oauthClientId') || '').trim();
    },
    redditEnabled() {
      return !!this.$state.setting('reddit.enabled') && !!this.cleanSub;
    },
    cleanSub() {
      const s = String(this.$state.setting('reddit.subreddit') || '').trim();
      return s.replace(/[^a-zA-Z0-9_]/g, '');
    },
    subSort() {
      var _context;
      const s = this.$state.setting('reddit.sort') || 'hot';
      return (0, _includes.default)(_context = ['hot', 'new', 'top', 'rising']).call(_context, s) ? s : 'hot';
    },
    subLimit() {
      const n = parseInt(this.$state.setting('reddit.limit'), 10);
      if (Number.isNaN(n) || n < 1) {
        return 15;
      }
      return Math.min(50, n);
    },
    subTitle() {
      const d = this.$state.setting('reddit.displayName');
      if (typeof d === 'string' && d.trim()) {
        return d.trim();
      }
      return this.cleanSub ? `r/${this.cleanSub}` : 'Reddit';
    },
    subredditUrl() {
      return this.cleanSub ? `https://www.reddit.com/r/${this.cleanSub}/` : 'https://www.reddit.com/';
    }
  },
  created() {
    this.listen(this.$state, 'reddit.panel.show', () => {
      this.open();
    });
    this.listen(this.$state, 'reddit.panel.hide', () => {
      this.close();
    });
    this.listen(this.$state, 'reddit.panel.toggle', () => {
      if (this.visible) {
        this.close();
      } else {
        this.open();
      }
    });
    this.listen(document, 'keydown', this.onDocKeydown);
  },
  methods: {
    onDocKeydown(ev) {
      if (this.visible && ev.key === 'Escape') {
        this.close();
        ev.preventDefault();
      }
    },
    async open() {
      if (!this.redditEnabled) {
        return;
      }
      this.visible = true;
      await this.refreshRedditOAuthStatus();
      this.loadPosts();
    },
    close() {
      this.visible = false;
      this.loadError = '';
    },
    async loadPosts() {
      this.loading = true;
      this.loadError = '';
      this.posts = [];
      try {
        const list = await (0, _RedditSubApi.fetchSubredditPosts)({
          subreddit: this.cleanSub,
          sort: this.subSort,
          limit: this.subLimit,
          oauthClientId: String(this.$state.setting('reddit.oauthClientId') || ''),
          oauthClientSecret: String(this.$state.setting('reddit.oauthClientSecret') || '')
        });
        if (!list.length && !window.electronAPI?.redditGetPosts) {
          this.loadError = 'El listado solo está disponible en la app de escritorio (Electron).';
        } else {
          this.posts = list;
        }
      } catch (err) {
        this.loadError = err && err.message ? String(err.message) : 'No se pudo cargar Reddit.';
      } finally {
        this.loading = false;
      }
    },
    async refreshRedditOAuthStatus() {
      if (!window.electronAPI || typeof window.electronAPI.redditOAuthStatus !== 'function') {
        this.redditOAuthConnected = false;
        return;
      }
      try {
        const s = await window.electronAPI.redditOAuthStatus();
        this.redditOAuthConnected = !!(s && s.connected);
      } catch {
        this.redditOAuthConnected = false;
      }
    },
    async startRedditOAuth() {
      if (!this.oauthClientConfigured || typeof window.electronAPI?.redditOAuthStart !== 'function') {
        return;
      }
      this.oauthBusy = true;
      this.loadError = '';
      try {
        await window.electronAPI.redditOAuthStart({
          clientId: String(this.$state.setting('reddit.oauthClientId') || '').trim(),
          clientSecret: String(this.$state.setting('reddit.oauthClientSecret') || '').trim(),
          redirectUri: String(this.$state.setting('reddit.oauthRedirectUri') || 'http://127.0.0.1:17890/reddit/callback').trim(),
          scopes: String(this.$state.setting('reddit.oauthScopes') || 'read identity').trim()
        });
        await this.refreshRedditOAuthStatus();
        await this.loadPosts();
      } catch (e) {
        this.loadError = e && e.message ? String(e.message) : 'OAuth Reddit falló.';
      } finally {
        this.oauthBusy = false;
      }
    },
    async logoutRedditOAuth() {
      if (typeof window.electronAPI?.redditOAuthLogout !== 'function') {
        return;
      }
      this.oauthBusy = true;
      try {
        await window.electronAPI.redditOAuthLogout();
        await this.refreshRedditOAuthStatus();
        await this.loadPosts();
      } finally {
        this.oauthBusy = false;
      }
    },
    openPost(p) {
      const u = p.url && p.url.startsWith('http') ? p.url : p.permalink || this.subredditUrl;
      if (typeof window !== 'undefined' && window.electronAPI && typeof window.electronAPI.openExternal === 'function') {
        window.electronAPI.openExternal(u);
      } else {
        window.open(u, '_blank', 'noopener,noreferrer');
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["RedditSubDrawer"]
window._kiwi_exports.components.RedditSubDrawer = exports.default ? exports.default : exports;
